//import { Test } from './Test';
import { Source } from './Source';
export class User {
  Id: string;
  FirstName: string;
  LastName: string;
  Email: string;
  Tel: string;
  //Tests: Test[];
  Site: number;
  Sources: Source[];
  Clinician: string;
  IsPasswordNeedReset: boolean;
  HasAcceptedTandC: boolean;
  CanViewResults: boolean;
  CanOrderKits: boolean;
  CanSeeAllSiteResults: boolean;
  CanRequest: boolean;
}
